import { Component, Input, OnInit, Output, ViewEncapsulation, EventEmitter, OnDestroy, ViewChild, ElementRef } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import {FormBuilder, FormControl} from '@angular/forms';
import moment from 'moment-timezone';
import { Subscription } from 'rxjs';
import { ApService } from 'src/app/shared/services/ap.service';
import { DialogChartContentComponent } from '../dialog-chart-content/dialog-chart-content.component';
import { Timezone } from 'src/app/shared/model/timezone'

import { resolveDeviceTimezone } from 'src/app/shared/helper/device-timezone';

@Component({
  selector: 'app-device-monitor-analytics',
  templateUrl: './device-monitor-analytics.component.html',
  styleUrls: ['./device-monitor-analytics.component.scss']
})

export class DeviceMonitorAnalyticsComponent implements OnInit, OnDestroy {
  registeredLinks = [];
  mosData = [];
  bandData = [];
  linkState = [];
  linkLatency = [];
  dataUsageChart = [];
  graphData = [];
  upTime: any;
  dataUsage: any
  type = 0;
  res: any;
  _device: any;
  dpcDataArray: any[] = [];
  dpcData: any[] = [];
  vHub_mode: boolean = false;
  searchPipe = "";
  deviceForm: any;
  timezoneArray = Timezone;
  selectedTimezone = 'utc';
  private readonly timelineMap = {
    0: { value: '4hrs', key: 'last4Hours', interval: 3 },
    1: { value: '24hrs', key: 'last24Hours', interval: 12 },
    2: { value: '7days', key: 'last7Days', interval: 72 },
    3: { value: 'thisMonth', key: 'thisMonth', interval: 432 },
    4: { value: 'lastMonth', key: 'lastMonth', interval: 432 }
  };

  @Input() set device(obj) {
    if (obj) {
      this._device = obj;
      this.vHub_mode = obj[0]?.templateConfig?.team?.config?.team1?.mode == 'VHUB' ? true : false;
      this.selectedTimezone = resolveDeviceTimezone(this._device?.[0]?.statistics?.timezone);
      this.deviceForm.controls.searchTimezone.setValue(this.selectedTimezone);
      this.registeredLinks = this._device?.[0]?.statistics?.teams?.team1?.links
        ?.map(x => x.link)
        ?.filter(l => l) || [];
      this.loadHistoryData(0);
    }
  }
  @Input() dataSource;
  @Output() edit = new EventEmitter();
  

  private loadDataSubscription: Subscription;

  constructor(
    private formBuilder: FormBuilder,
    public apService: ApService,
    public dialog: MatDialog,
  ) { 
    this.deviceForm = this.formBuilder.group({
      searchTimezone: new FormControl(null)
    });
  }

  ngOnInit(): void {    
  }

  loadHistoryData(t) {
    if (!this._device[0]) {
      return;
    }
    this.type = t;
    const timelineConfig = this.timelineMap[this.type] || this.timelineMap[0];
    const interval = timelineConfig.interval;
    if(this.type !==5){
      let data =  {
        timeline: timelineConfig.value
      }
      this.loadDataSubscription = this.apService.getDevicesHistoryDataById(this._device[0]._id, data).subscribe(res => {
        if (!res || !res.data || !res.data.lists) {
          return;
        }
        this.res = res;
        this.graphData = res.data.lists
        .map(h => ({
          ...h,
          ...{ datetime: this.type == 1 ? h.datetime.split(" - ")[0].substring(h.datetime.split(" - ")[0].indexOf(" ") + 1) : h.datetime.split(" - ")[0], },
        })).filter((m, index) => {
          return index && (index % interval == 0 || index == res.data.lists.length - 1);
        })
        if (this.type == 1) {
          this.upTime = String(res.data.lists[res.data.lists.length - 1]?.['Device Uptime']);
        }
        const timelineData = this.getTimelineData(res.data.timelines, timelineConfig.key);
        this.dataUsage = {
          "histdata": this.res.data.lists,
          "LastHistData": res.data.lists[res.data.lists.length - 1],
          "timelineSummary": timelineData?.table || null
        }
      })
    }
      
  }

  private getTimelineData(timelines: any, preferredKey: string) {
    if (!timelines) {
      return null;
    }
    if (preferredKey && timelines[preferredKey]) {
      return timelines[preferredKey];
    }
    const firstKey = Object.keys(timelines)[0];
    return firstKey ? timelines[firstKey] : null;
  }

  selectedTabChange(evt) {
    this.type = evt.index;
    this.loadHistoryData(this.type);
  }

  openDialog(type) {
    let interval = this.type == 0 ? 1 : this.type == 1 ? 6 : this.type == 2 ? 36 : this.type == 3 ? 72 : this.type == 4 ? 72 : 1
    let data
    if(type == 0){       
      data = this.res.histdata.map(h => ({
        ...h,
        ...{ datetime: this.type == 1 ? h.datetime.split(" - ")[0].substring(h.datetime.split(" - ")[0].indexOf(" ") + 1) : h.datetime.split(" - ")[0], },
      })).filter((m, index) => {
        return index && (index % interval == 0 || index == this.res.histdata.length - 1);
      })
    } else {       
      data = this.res.data.lists.map(h => ({
        ...h,
        ...{ datetime: this.type == 1 ? h.datetime.split(" - ")[0].substring(h.datetime.split(" - ")[0].indexOf(" ") + 1) : h.datetime.split(" - ")[0], },
      })).filter((m, index) => {
        return index && (index % interval == 0 || index == this.res.data.lists.length - 1);
      })
    }
   
    const dialogRef = this.dialog.open(DialogChartContentComponent, {
      data: {
        chartData: data,
        type: type,
        registeredLinks: this.registeredLinks,
      }
    });

    dialogRef.afterClosed().subscribe(result => { });
  }

  editDevice() {
    this.edit.emit();
  }

  isUsefulData() {
    return this.graphData.length && Object.keys(this.graphData[0]).length>3
  }

  onSelectionChange(event){
    if(event.value){
      this.selectedTimezone = event.value;
      this.loadHistoryData(this.type);
    }
  }

  searchFocus(){
    // setTimeout(() => {
    //   this.searchElement.nativeElement.focus();
    // }, 50);
  }
  ngOnDestroy(): void {
    if (this.loadDataSubscription) {
      this.loadDataSubscription.unsubscribe();
    }
  }
}
